export function getError(error) {
  if (!error.isError) {
    if (window._dataLayer && window._dataLayer.appInfo.errors) {
      return window._dataLayer.appInfo.errors;
    }
    return {
      errorCode: '',
      errorMessage: '',
      currentPage: ''
    };
  }
  const { message, code } = error;
  if (message === 'Loading error') {
    return {
      errorCode: '404',
      errorMessage: `${message}: Screen not loaded for ${window.location.pathname}`,
      currentPage: window.location.pathname
    };
  }
  return {
    errorCode: code,
    errorMessage: message,
    currentPage: window.location.pathname
  };
}
